var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSearch(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.66663 3.33329C6.44496 3.33329 3.83329 5.94497 3.83329 9.16663C3.83329 12.3883 6.44496 15 9.66663 15C11.2382 15 12.6647 14.3784 13.7136 13.3678C13.7355 13.3393 13.7596 13.3118 13.7857 13.2857C13.8118 13.2596 13.8393 13.2355 13.8678 13.2136C14.8784 12.1647 15.5 10.7382 15.5 9.16663C15.5 5.94497 12.8883 3.33329 9.66663 3.33329ZM15.5265 13.848C16.5529 12.565 17.1666 10.9375 17.1666 9.16663C17.1666 5.02449 13.8088 1.66663 9.66663 1.66663C5.52449 1.66663 2.16663 5.02449 2.16663 9.16663C2.16663 13.3088 5.52449 16.6666 9.66663 16.6666C11.4375 16.6666 13.065 16.0529 14.348 15.0265L17.4107 18.0892C17.7361 18.4147 18.2638 18.4147 18.5892 18.0892C18.9146 17.7638 18.9146 17.2361 18.5892 16.9107L15.5265 13.848Z",
    fill: "#969597"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearch);
export default __webpack_public_path__ + "static/media/search.bbbf4e295b6eee9f46ebf801603f6d08.svg";
export { ForwardRef as ReactComponent };